  <back-button [title]="title" [url]="backUrl"></back-button>

<app-page-container [title]="tableName">
  <app-table [tableKey]="tableKey"
             [displayedColumns]="displayedColumns"
             [data]="data"
             [length]="length"
             [isSearchOn]="false"
             [dataType]="dataType"
             (tableData)="getDetailedReport($event)"
             (actionEmit)="actionHandler($event)"
             [filterMessageRules]="filterRules">
  </app-table>
</app-page-container>
